/**
 * The letters a word activity adds besides the word's own (WordSlide's fake
 * letters, the editor's other options of a "missing letter"): the alphabet of
 * the word's script. The Unity app only had the Latin one; Cyrillic words get
 * Ukrainian, Bulgarian or Russian letters (as the word or the interface's
 * language says), Greek words Greek ones, Hebrew words Hebrew ones, and words
 * in the Arabic script Urdu, Persian or Arabic letters (the same way).
 */
import { currentLanguage } from "./i18n";

const LATIN = "abcdefghijklmnopqrstuvwxyz";
const RUSSIAN = "абвгдежзийклмнопрстуфхцчшщыэюя";
const UKRAINIAN = "абвгґдеєжзиіїйклмнопрстуфхцчшщьюя";
const BULGARIAN = "абвгдежзийклмнопрстуфхцчшщъьюя";
const GREEK = "αβγδεζηθικλμνξοπρστυφχψω";
const HEBREW = "אבגדהוזחטיכלמנסעפצקרשת";
const ARABIC = "ابتثجحخدذرزسشصضطظعغفقكلمنهوي";
const PERSIAN = "ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی";
const URDU = "ابپتٹثجچحخدڈذرڑزژسشصضطظعغفقکگلمنوہیے";

/** Lower-case letters of the alphabet `sample` is written in. */
export function alphabetFor(sample: string): string {
  const lang = currentLanguage();
  if (/[Ͱ-Ͽ]/.test(sample)) return GREEK;
  if (/[Ѐ-ӿ]/.test(sample)) return /[ґєії]/i.test(sample) || lang === "uk" ? UKRAINIAN : lang === "bg" ? BULGARIAN : RUSSIAN;
  if (/[֐-׿]/.test(sample)) return HEBREW;
  if (/[؀-ۿ]/.test(sample)) return /[ٹڈڑںےۓہ]/.test(sample) || lang === "ur" ? URDU : /[پچژگکی]/.test(sample) || lang === "fa" ? PERSIAN : ARABIC;
  return LATIN;
}
